module.exports = __webpack_public_path__ + "img/header-weddingRingsCheap.2456d52.jpg";